<!-- =========================================================================================



    ?created?/?mounted?
        sync with business data

    Local data:      
      
      description: '',
      title: ''
      initialData: "[JSON]"


-->

<template>
  <div id="dashboard-analytics">
    <pagesubtitle subTitle="The best way to get customer feedback, is to start asking! Share your feedback link with your followers."/>    
    <div class="p-4 my-3 rounded flex items-center" style="background: #EBCDF4;">
      <feather-icon icon="InfoIcon" svgClasses="stroke-current text-light w-6 h-6" class="mx-2" />
      <span class="font-medium">Be sure to check your settings below before you share. If you change settings after sharing, changes may take time to reflect accross different platforms.</span>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full lg:w-8/12 flex mb-base">
        <vx-card title="TITLE & DESCRIPTION" slot="no-body" class="">                  
          <div class="vx-row ">
            <div class="vx-col w-full lg:w-2/3">
            <p class="w-full">Change the title and description of the post when someone shares your feedback link on social media. </p>          
             <vs-collapse type="margin" :open-hover="true" class="small mb-base" >
                <vs-collapse-item icon-pack="feather" icon-arrow="icon-help-circle" class="text-left">
                  <div slot="header">
                    More info
                  </div>
                  <p class="mb-4">This is the information shown on Social Media when someone shares a post containing your feedback link. This will appear accross platforms like Facebook, Twitter etc.</p>
                  <img class="w-full block max-w-xs" src="@/assets/images/misc/opengraph.png"/>
                </vs-collapse-item>
              </vs-collapse>      
              <vs-input
                    v-model="title"            
                    v-validate="'required|max:80'"
                    label="Title"
                    name="Title"
                    placeholder="Title of share/tweet post"
                    class="w-full mt-2"
                  />
                  <span class="text-danger block my-4">{{ errors.first('Title') }}</span>
                <vs-input
                    v-model="description"    
                    label="Description"        
                    v-validate="'required|max:120'"
                    name="Description"
                    placeholder="Description of share/tweet post"
                    class="w-full mt-2"
                  />
                <span class="text-danger block my-4">{{ errors.first('Description') }}</span>
              </div>
          </div>
          <div class="flex mt-4">
            <vs-button :disabled="!updateAllowed" class="block px-32" @click="updateOpenGraph">Update</vs-button>
          </div>
        </vx-card>
      </div>

      <div class="vx-col w-full lg:w-4/12 mb-base flex">
        <vx-card class="greet-user" title="Share">
          <p>Select a platform where you'd like to ask for feedback. A new window will pop-up where a post/tweet will be generated.</p>
          <div class="my-6">
            <vs-button :href="fbURL" target="_blank" size="large"  class="w-full my-3" color="#3B5998" icon-pack="feather" icon="icon-external-link" icon-after >Share on Facebook</vs-button>
            <vs-button :href="linkedInURL" target="_blank" size="large"  class="w-full my-3" color="#0072B1" icon-pack="feather" icon="icon-external-link" icon-after >Share on LinkedIn</vs-button>
            <vs-button :href="twitterURL" target="_blank" size="large" class="w-full my-3" color="#1DA1F2" icon-pack="feather" icon="icon-external-link" icon-after >Tweet</vs-button>
          </div>
          <p>Write an enticing and engaging message for your social post descriptions. Be sure to mention what you'll do with feedback and why you need it!</p>
        </vx-card>
      </div>
    </div>
  </div>
</template>


<script>


/*

Sep '22

MVP 2.0:


<div class="vx-row">
            <div class="vx-col lg:w-1/2">
              <label class="vs-input--label">Share Image</label>   
              <p>The image shown on Social Media when your feedback link is shared.</p>
              <vs-collapse type="margin" :open-hover="true" class="small mb-base" >
                <vs-collapse-item icon-pack="feather" icon-arrow="icon-help-circle" class="text-left">
                  <div slot="header">
                    More info
                  </div>
                  <p class="mb-4">This is the image shown on Social Media when someone shares a post containing your Feedback Link. This will appear accross platforms like Facebook, Twitter etc.</p>
                  <img class="w-full block max-w-xs" src="@/assets/images/misc/opengraph.png"/>
                </vs-collapse-item>
              </vs-collapse>       
              <vs-radio v-model="imageSetting " vs-value="text" class="text-dark font-medium">
                Custom text
              </vs-radio>
              <div>
                  <vs-input
                    v-model="customImageText"            
                    v-validate="'required|max:50'"
                    name="Custom image text"
                    placeholder="Text for custom image"
                    class="w-full mt-2"
                  />
                  <span class="text-danger block mt-4">{{ errors.first('Custom image text') }}</span>
              </div>
              <vs-radio v-model="imageSetting " vs-value="screenshot" class="text-dark font-medium">
                Screenshot of survey
              </vs-radio>
            </div>
            <div class="vx-col lg:w-1/2">
              <p class="text-sm mb-2 mt-4 lg:mt-0">Preview</p>
              <img class="w-full block max-w-xs" src="@/assets/images/misc/opengraph.png"/>
            </div>
          </div>


*/


import Pagesubtitle from './components/ptcomponents/Pagesubtitle.vue'

export default {
  data () {
    return {      
      description: this.$store.getters['dash/currentLanguagePack'].welcomeInstructions,      
      title: this.$store.getters['dash/currentLanguagePack'].welcomeSecondary,
      initialData: ''
    }
  },
  components: {
    Pagesubtitle
  },
  methods: {
    init() {
 const eData = this.$store.state.dash.viewData.business
    if (typeof eData.surveySetup.opengraph !== 'undefined') {
      const OGData = eData.surveySetup.opengraph
      this.initialData = JSON.stringify(OGData)
      this.description = OGData.description
      this.title = OGData.title
    } else {
      this.initialData = JSON.stringify({
        description: this.description,
        title: this.title
      })
    }
    },
    updateOpenGraph() {
       if (this.updateAllowed) {
        this.$vs.loading()
        this.$store.dispatch('dash/UPDATE_OPEN_GRAPH', {
         title: this.title,
         description: this.description 
        }).then(() => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Updated sharing settings',
            text: 'Share settings updated. If you changed settings after sharing, it may take time to reflect accross different platforms.',
            color: 'success',
            time: 20000,
            iconPack: 'feather',
            icon:'icon-check'})
        }).catch(() => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Sharing settings',
            text:'Oops! Something went wrong, and we couldn\'t update your sharing settings. Please try again, and let us know us if it happens again: support@feedback.link',
            color: 'warning',
            time: 10000,
            iconPack: 'feather',
            icon:'icon-alert-circle'})
        })
      }
    }
  },
  computed: {
    updateAllowed () {
      //is form complete
      if (this.errors.any() || this.initialData === JSON.stringify({
        description: this.description,
        title: this.title
      })) return false
      return true
    },
    linkedInURL(){
       return 'http://www.linkedin.com/shareArticle?mini=true&url=' + encodeURIComponent(this.$store.getters['dash/feedbackURLPublic'])
    },
    fbURL() {
      //return 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent('https://feedback.link/bmvvkh')
      return 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(this.$store.getters['dash/feedbackURLPublic'])
    },
    twitterURL() {
      let urlToShare = encodeURIComponent(this.$store.getters['dash/feedbackURLFullPublic'])
      let text = encodeURIComponent('We\'d love to hear your feedback on your experience with us, please help us improve! Visit ')
      let hashtags = 'feedback,service,recommendation,thankyou'
      return 'https://twitter.com/intent/tweet?text=' + text + '&hashtags=' + hashtags + (urlToShare ? '&url=' + urlToShare : '')
    },
  },
  created () {

   this.init()

  }
}
</script>

<style lang="scss">
/*! rtl:begin:ignore */
#dashboard-analytics {
  .greet-user{
    position: relative;

    .decore-left{
      position: absolute;
      left:0;
      top: 0;
    }
    .decore-right{
      position: absolute;
      right:0;
      top: 0;
    }
  }

  @media(max-width: 576px) {
    .decore-left, .decore-right{
      width: 140px;
    }
  }
}
/*! rtl:end:ignore */
</style>
